import axios from "axios";
import { setHeader, axiosGet, axiosPost, axiosPut } from "../options/header"

export default {
  getAllCurrency() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/financial/currency",
        {
           credentials: true
        });
    } catch (err) {
      console.log(err);
    }
  },
  getSifarnik() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/financial/sifarnik",
        {
           credentials: true
        });
    } catch (err) {
      console.log(err);
    }
  },
  getAllServiceTypes() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/financial/service-types",
        {
           credentials: true
        });
    } catch (err) {
      console.log(err);
    }
  },
  getBillingTypes() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/financial/billing-types",
        {
           credentials: true
        });
    } catch (err) {
      console.log(err);
    }
  },
  getBreakdown(troskovnik_id) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/financial/troskovnici/breakdown/" + troskovnik_id,
        {
           credentials: true
        });
    } catch (err) {
      console.log(err);
    }
  },
  getCaseRootFolder(case_id) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/financial/troskovnici/root-folder/" + case_id,
        {
           credentials: true
        });
    } catch (err) {
      console.log(err);
    }
  },
  getFirstLevelFolders(case_id) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/financial/troskovnici/first-level-folders/" + case_id,
        {
           credentials: true
        });
    } catch (err) {
      console.log(err);
    }
  },
  getCaseTroskovnici(case_id, smjer, person_uid, filter_type, start_date, end_date, sort_type, selektirani_tip_foldera) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/financial/troskovnici/" + case_id, {
        params: {
          smjer: smjer,
          person_uid: person_uid,
          filter_type: filter_type,
          start_date: start_date,
          end_date: end_date,
          sort_type: sort_type,
          selektirani_tip_foldera: selektirani_tip_foldera
        },
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  getAllTroskovnici(smjer, filter_type, start_date, end_date, selektirana_osoba, sort_type, selektirani_tip_foldera) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/financial/all-troskovnici", {
        params: {
          smjer: smjer,
          filter_type: filter_type,
          start_date: start_date,
          end_date: end_date,
          selektirana_osoba: selektirana_osoba,
          sort_type: sort_type,
          selektirani_tip_foldera: selektirani_tip_foldera,
        },
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  getAllNalozi(start,end,is_invoiced) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/financial/all-nalozi", {
        params:{
            start,end,is_invoiced
        },
        credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  addTroskovnik(troskovnik_data) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/financial/troskovnici/", {
        params: {
          troskovnik_data: troskovnik_data
        },
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  setInvoicedStatus(form_data) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/financial/set-status", form_data, {
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getGraphInvoice(racun_id) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/financial/get-graph-racun/" + racun_id, {
        credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  printAllTroskovnici(id_folder, filter_type, start_date, end_date, selektirana_osoba, selektirani_tip_foldera) {
    try {
      return axios({
        method: 'POST',
        url: process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/financial/troskovnici/print-troskovnici",
        data: {
          id_folder: id_folder,
          filter_type: filter_type,
          start_date: start_date,
          end_date: end_date,
          selektirana_osoba: selektirana_osoba,
          selektirani_tip_foldera: selektirani_tip_foldera
        },
        responseType: "arraybuffer",
        encodeURI: "UTF-8",
        headers: setHeader().headers,
        credentials: true
      })
    } catch {
      console.log("Failed to merge documents");
    }
  },
  editTroskovnik(troskovnik_data) {
    try {
      return axiosPut(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/financial/troskovnici/", {
        params: {
          troskovnik_data: troskovnik_data
        },
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  renameTroskovnik(id_troskovnik, new_name) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/financial/troskovnici/rename-troskovnik", {
        params: {
          id_troskovnik: id_troskovnik,
          new_name: new_name
        },
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  renameNaplataFolder(id_folder, new_name) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/financial/troskovnici/rename-folder", {
        params: {
          id_folder: id_folder,
          new_name: new_name
        },
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  deleteTroskovnik(id_troskovnik) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/financial/troskovnici/delete-troskovnik", {
        params: {
          id_troskovnik: id_troskovnik,
        },
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  deleteNaplataFolder(id_folder) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/financial/troskovnici/delete-folder", {
        params: {
          id_folder: id_folder,
        },
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  createFolder(parent_id, case_id, folder_name, person_id, move_file_id) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/financial/troskovnici/create-naplata-folder", {
        params: {
          parent_id: parent_id,
          case_id: case_id,
          folder_name: folder_name,
          person_id: person_id,
          move_file_id: move_file_id
        },
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  moveItem(id_folder, id_troskovnik, parent_id) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/financial/troskovnici/move-item", {
        params: {
          id_folder: id_folder,
          id_troskovnik: id_troskovnik,
          parent_id: parent_id,
        },
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },

  addXmlBank(form_data) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/financial/bank-xml", form_data, {
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },



  //CASH FLOW
  getMyAccounts() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/financial/identyum/accounts", {
        params:{},
        credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },

  //CASH FLOW
}